import { Component, OnInit, Input, EventEmitter, Output, ElementRef } from '@angular/core';
import { Tag } from '../../store/model/tag.model';

@Component({
  selector: 'rl-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss', './tag.component-rtl.css']
})
export class TagComponent implements OnInit {

  constructor(private e : ElementRef) { }

  @Input() tag : Tag;
  @Input() hideRemove : boolean;
  @Output() onRemove : EventEmitter<Tag> = new EventEmitter<Tag>();

  uniqueId : string;

  ngOnInit(): void {
    this.uniqueId = this.e.nativeElement.id;
  }

  remove(){
    this.onRemove.emit(this.tag);
  }

}
